import React from "react";
import Card from "../../../../core/Card";
import Typography from "../../../../core/Typography";
import { useDevice } from "../../../customHooks";
import { useEffect, useRef, useState } from "react";
import style from "../../../style.module.css";
import { Icon } from "@blueprintjs/core";
import loading from "../../../../assets/loading.svg";
import Title from "../Title";	
import {Link} from "react-router-dom";

export const JoiningRequestExistingAccount = () => {
  let device = useDevice();
  const [isOpen, setOpen] = useState(false);
  const inputRef = useRef();
  const [count, setCount] = useState(0);
  const [isChecked, setChecked] = useState(false);

  useEffect(() => {
    const str = String(inputRef?.current?.props.value)?.length;
    setCount(str);
  }, []);

  const handleCount = e => {
    setCount(String(e.target.value).length);
  };
  return (
    <div className={"formcontainer" + " " + style.container}>
      <Link to="/"><Title /></Link>
      <div className={style.wrapper}>

      <Card view="raised" className={"formstyle" + " " + style.card}
          style={{ textAlign: "center" }}
        >
          <Typography className={"formsubhead"}
            type={device === "mobile" ? "caption" : "body"}
            colorStep={50}
            tagName="div"
            large={device !== "mobile"}

          > < Icon icon='tick-circle' iconSize={110} color="#2979FF" />
          </Typography>
          <Typography
            type={device === "mobile" ? "h6" : "h5"}
            colorStep={100}
            tagName="div"
            style={{ textAlign: "center" }}
            className={"formhead"}
          >
            Success!
          </Typography>
          <Typography className={"formsubhead"}
            type={device === "mobile" ? "caption" : "body"}
            colorStep={50}
            tagName="div"
            large={device !== "mobile"}
            icon={< Icon icon='info-sign' iconSize={16} />}
          >  Congratulations! our password has been changed successfully
          </Typography>
          <Typography className={"formsmalltext"}
            type={device === "mobile" ? "caption" : "body"}
            colorStep={50}
            tagName="div"
            large={device !== "mobile"}
            icon={< Icon icon='info-sign' iconSize={16} />}
          >
            <strong>Redirecting in</strong> 3s...to Sign-in page  
          </Typography>

        </Card>
      </div>

    </div>
  );
};

export default JoiningRequestExistingAccount;
